import { __awaiter } from "tslib";
import { signupFormChanged } from '../../store/shared-signup';
import { getRegions } from './avatax';
export const updateSignupForm = (field, value) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    if (field === 'country') {
        const { countries } = getState().data;
        if (!countries.some(c => c.code === value))
            return;
    }
    dispatch(signupFormChanged({ field, value }));
    if (field === 'country')
        dispatch(getRegions(value));
});
